import { Icon } from "@circle-react/components/shared/Icon";

export const BotAvatar = () => (
  <div className="from-circle flex size-[40px] shrink-0 justify-center overflow-hidden rounded bg-gradient-to-b to-[#6B47D2] text-white">
    <Icon type="20-ai" size={20} />
  </div>
);
